// TODO: organise build process and project/package dependencies and import the function instead
// Note: this section is copied from
// NG.FrontEnd\Website\src\common.js
// and
// NG.FrontEnd\Website\src\components\image-credit\image-credit-toggle.js
export default () => {
  // Note: below from NG.FrontEnd\Website\src\common.js
  const toggleAttribute = (element, attr) => {
    // Return without error if element or attr are missing
    if (!element || !attr) return;
    // Toggle attribute value. Treat no existing attr same as when set to false
    const value = (element.getAttribute(attr) === 'true') ? 'false' : 'true';
    element.setAttribute(attr, value);
  };

  // Note: below from NG.FrontEnd\Website\src\components\image-credit\image-credit-toggle.js
  // HTMLelements
  /** @type {NodeListOf<HTMLButtonElement>} */
  const imageCreditToggleButton = document.querySelectorAll(
    '[data-image-credit-toggle]'
  );
  const toggleImageCredit = (event) => {
    event.preventDefault();
    /** @type {HTMLElement} */
    const btn = event.currentTarget;

    // Toggle aria-expanded for accessiblity
    toggleAttribute(btn, 'aria-expanded');
    // Toggle classes to apply CSS
    btn.classList.toggle('is-active');
    /** @ {HTMLElement} */
    const imageCreditContentCaption = btn.nextElementSibling;
    imageCreditContentCaption.classList.toggle('d-none');
    /** @ {HTMLElement} */
    const imageCreditCameraIcon = btn.firstElementChild;
    imageCreditCameraIcon.classList.toggle('d-none');
    /** @ {HTMLElement} */
    const imageCreditCloseIcon = btn.lastElementChild;
    imageCreditCloseIcon.classList.toggle('d-none');
  };
  if (imageCreditToggleButton.length) {
    imageCreditToggleButton.forEach(
      (/** @type {HTMLButtonElement} */ element) => {
            element.addEventListener('click', toggleImageCredit);
      }
    );
  }
}